import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const TermsPage = () => {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative pt-32 pb-12 bg-brand-dark overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20clean%20minimal%20background%20texture%20light%20pattern%20professional%20website%20terms%20of%20service%20legal%20document&width=1920&height=300&seq=terms1&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="flex items-center justify-center gap-2 text-white/50 text-sm font-body mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white">Terms of Service</span>
            </div>
            <h1 className="font-heading font-black text-white text-4xl md:text-5xl mb-3">Terms of Service</h1>
            <p className="font-body text-white/60 text-sm">Last updated: April 6, 2026</p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="font-body text-gray-600 text-sm leading-relaxed space-y-8">

              <div className="bg-brand-beige rounded-2xl p-5">
                <p>
                  Please read these Terms of Service carefully before using the website or services of <strong className="text-brand-dark">Adry &amp; Mich Cleaning and Handyman Service</strong>. By accessing our website or booking our services, you agree to be bound by these terms. If you do not agree, please do not use our services.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">1. Services</h2>
                <p className="mb-3">
                  Adry &amp; Mich Cleaning and Handyman Service provides residential and commercial cleaning services, as well as handyman services including but not limited to drywall repair, interior painting, pressure washing, and TV mounting in the Royal Palm Beach, FL area and surrounding Palm Beach County.
                </p>
                <p>
                  All services are subject to availability. We reserve the right to refuse service to anyone for any reason at any time.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">2. Booking and Scheduling</h2>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Service appointments must be scheduled in advance via phone, WhatsApp, email, or our website contact form.</li>
                  <li>A confirmed booking is subject to availability and will be confirmed by our team.</li>
                  <li>We reserve the right to reschedule appointments due to unforeseen circumstances such as weather conditions or staff emergencies. We will notify you as soon as possible in such cases.</li>
                  <li>Please ensure that our team has safe and unobstructed access to the property at the scheduled time.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">3. Cancellation Policy</h2>
                <ul className="list-disc pl-5 space-y-2">
                  <li><strong className="text-brand-dark">24-Hour Notice:</strong> We require at least 24 hours notice for cancellations or rescheduling.</li>
                  <li><strong className="text-brand-dark">Late Cancellations:</strong> Cancellations made less than 24 hours before the scheduled appointment may be subject to a cancellation fee.</li>
                  <li><strong className="text-brand-dark">No-Shows:</strong> If our team arrives and cannot access the property, a trip fee may be charged.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">4. Pricing and Payment</h2>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Prices are provided as estimates and may vary based on the actual condition and size of the property.</li>
                  <li>Final pricing will be confirmed before service begins.</li>
                  <li>Payment is due upon completion of services unless otherwise agreed in writing.</li>
                  <li>We accept cash, Zelle, Venmo, and other payment methods as agreed upon at the time of booking.</li>
                  <li>Prices are subject to change without notice. Existing confirmed bookings will honor the quoted price.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">5. Client Responsibilities</h2>
                <p className="mb-3">To ensure the best service experience, clients agree to:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Provide safe and unobstructed access to the property at the scheduled time</li>
                  <li>Secure or remove fragile, valuable, or irreplaceable items before service</li>
                  <li>Inform us of any special instructions, hazards, or areas to avoid</li>
                  <li>Ensure pets are secured during the service visit</li>
                  <li>Provide access to water and electricity as needed for the service</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">6. Satisfaction Guarantee</h2>
                <p>
                  We take pride in our work and strive for 100% customer satisfaction. If you are not satisfied with any aspect of our service, please notify us within 24 hours of service completion. We will return to address any missed areas or concerns at no additional charge. Claims made after 24 hours may not be eligible for a re-clean.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">7. Liability</h2>
                <ul className="list-disc pl-5 space-y-2">
                  <li>We carry general liability insurance. In the event of damage caused by our team, please notify us within 24 hours.</li>
                  <li>We are not responsible for pre-existing damage or wear and tear.</li>
                  <li>Our liability is limited to the cost of the service provided.</li>
                  <li>We are not liable for any indirect, incidental, or consequential damages.</li>
                  <li>Clients are responsible for securing valuables. We are not liable for loss of items not reported before service.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">8. Website Use</h2>
                <p className="mb-3">By using our website, you agree that:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>You will not use the website for any unlawful purpose</li>
                  <li>You will not attempt to gain unauthorized access to any part of the website</li>
                  <li>You will not transmit any harmful, offensive, or disruptive content</li>
                  <li>All content on this website is the property of Adry &amp; Mich and may not be reproduced without permission</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">9. Governing Law</h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the laws of the State of Florida, United States, without regard to its conflict of law provisions. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts located in Palm Beach County, Florida.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">10. Changes to These Terms</h2>
                <p>
                  We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after any changes constitutes your acceptance of the new terms.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">11. Contact Us</h2>
                <p className="mb-3">If you have any questions about these Terms of Service, please contact us:</p>
                <div className="bg-brand-beige rounded-2xl p-5 flex flex-col gap-2">
                  <p className="font-heading font-bold text-brand-dark text-sm">Adry &amp; Mich Cleaning and Handyman Service</p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-map-pin-line text-brand-green"></i>
                    10639 Misty Ln, Royal Palm Beach, FL 33411
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-phone-line text-brand-green"></i>
                    <a href="tel:+15612626118" className="hover:text-brand-green transition-colors cursor-pointer">(561) 262-6118</a>
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-mail-line text-brand-green"></i>
                    <a href="mailto:adrimich7778@hotmail.com" className="hover:text-brand-green transition-colors cursor-pointer">adrimich7778@hotmail.com</a>
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-whatsapp-line text-brand-green"></i>
                    <a href="https://wa.me/15612626118" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors cursor-pointer">WhatsApp: (561) 262-6118</a>
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default TermsPage;
